<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:12:11
 * @LastEditTime: 2020-05-13 17:22:59
 * @LastEditors: 山淑兰
 -->

<template>
  <div class="modifyphone">
    <main>
      <div class="modifyphone-con" v-if="nowShow">
        <div class="title">
          修改手机号
        </div>
        <div class="now-tel">
          当前手机号
        </div>
        <div class="now-phone">
          {{userInfo.Phone}}      
        </div>
        <div class="now-code" v-if="codeShow">
          <div class="code-input">
            <input type="text" name="code" placeholder="请输入短信验证码" v-model="code">
          </div>
          <div class="code-btn">
            {{getCAPTCHA}}
          </div>
        </div>
        <div class="now-code-get" v-if="codeBtnShow" @click="getCode">
          获取验证码
        </div>
        <div class="now-code-get"  v-if="codeShow" @click="getSure">
          确定
        </div>
      </div>
      <div class="modifyphone-con" v-if="modfiyShow">
        <div class="title">
          输入新手机号
        </div>
        <div class="now-tel">
          输入新手机号
        </div>
        <div class="now-code">
          <div class="code-input">
            <input type="text" name="code" placeholder="请输入新手机号" v-model="modfiyphone">
          </div>
        </div>
        <div class="now-code">
          <div class="code-input">
            <input type="text" name="code" placeholder="请输入短信验证码" v-model="code1">
          </div>
          <div class="code-btn code-btn-active" v-if="send"  @click="getCode1">
            {{getCAPTCHA1}}
          </div>
          <div class="code-btn code-btn-no" v-else>
            {{getCAPTCHA1}}
          </div>
        </div>
        <div class="now-code-get" @click="modfiySure">
          确定
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: '',
      code: '',
      code1: '',
      modfiyphone: '',
      codeShow: false,
      codeBtnShow: true,
      getCAPTCHA: '',
      getCAPTCHA1: '获取验证码',
      send: true,
      nowShow: true,
      modfiyShow: false,
      fNavShow: true,

    }
  },
  created() {
    this.myInfo()
  },
  methods: {
    async myInfo() {
      try {
        const params = {m:this.$route.query.m};
        const res = await this.$http.userCentert(params);
        this.userInfo = res
      } catch (error) {
        console.error(error);
      }
    },
    //原手机验证码
    async getCode() {
      try {
        let _params = {
          m: this.$route.query.m,
          phone: this.userInfo.Phone,
        }
        const Res = await this.$http.verSendMsg(_params)

        if (Res.Code === 1000) {
          this.codeShow = true
          this.codeBtnShow = false
          // 开启倒计时
          let _time = 60
          let wstime = setInterval(() => {
            _time--
            this.getCAPTCHA = '验证码已发送'+ _time + 's'
            if (_time <= 0) {
              this.getCAPTCHA = ''
              clearTimeout(wstime)
              this.codeShow = false
              this.codeBtnShow = true
            }
          }, 1000)
        } else {
          this.codeShow = false
          this.codeBtnShow = true
          this.getCAPTCHA = ''
          this.$notify({
            message: Res.Msg,
            type: 'danger',
          })
        }
      } catch (err) {
        console.log(err)
      }
    },
    //原手机验证码验证
    async getSure() {
      try {
        let _params = {
            phone: this.userInfo.Phone,
            code: this.code,
        }
        const res = await this.$http.checkModfiyUser(_params);
        console.log(res)
        if (res.Code === 1000) {
          this.nowShow = false
          this.modfiyShow = true
        }
      } catch (error) {
        console.error(error);
      }
    },

    //新手机号的验证码
    async getCode1() {
      let telVal = this.modfiyphone
      let re = /^1[1-9]\d{9}$/
      let reTel = re.test(telVal)
      if (reTel === false) {
        this.$notify({
          message: '请输入正确的手机号!',
          type: 'danger',
        })
      }else if( this.modfiyphone == this.userInfo.Phone){
        this.$notify({
          message: '不能和原手机号相同呦~',
          type: 'danger',
        })
      }else{
        try {
          let _params = {
            m: this.$route.query.m,
            phone: this.modfiyphone,
          }
          const Res = await this.$http.verSendMsg(_params)

          if (Res.Code === 1000) {
            this.send = false
            // 开启倒计时
            let _time = 60
            let wstime = setInterval(() => {
              _time--
              this.getCAPTCHA1 = '验证码已发送'+ _time + 's'
              if (_time <= 0) {
                this.getCAPTCHA1 = '获取验证码'
                clearTimeout(wstime)
                this.send = true
              }
            }, 1000)
          } else {
            this.send = true
            this.getCAPTCHA1 = '获取验证码'
            this.$notify({
              message: Res.Msg,
              type: 'danger',
            })
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    //确认修改新的手机号
    async modfiySure() {
      let telVal = this.modfiyphone
      let re = /^1[1-9]\d{9}$/
      let reTel = re.test(telVal)
      if (reTel === false) {
        this.$notify({
          message: '请输入正确的手机号!',
          type: 'danger',
        })
      }else if(this.code1 == '' || this.code1 == null )  {
        this.$notify({
          message: '验证码不能为空!',
          type: 'danger',
        })
      }else{
        try {
          let _params = {
              modfiyphone: this.modfiyphone,
              code: this.code1,
          }
          const res = await this.$http.modfiyPhone(_params);
          console.log(res)
          if (res.Code === 1000) {
            this.$notify({
              message: "修改成功",
              type: 'success',
            })
            setTimeout(() => {
              this.$router.go(-1);
            }, 2000);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

};
</script>
<style lang="scss">
.modifyphone {
  padding-bottom: 85px;
  .modifyphone-con{
    padding: 100px 60px;
    font-size: 26px;
    color: #475569;
    .title{
      font-size: 38px;
      margin-bottom: 60px;
      color: #1e293b;
    }
    .now-phone{
      border-bottom: 1px solid #e2e8f0;
      margin-top: 20px;
      padding-bottom: 10px;
      font-size: 34px;
      color: #1e293b;
    }
    .now-code{
      display: flex;
      margin-top: 20px;
      height: 80px;
      line-height: 80px;
      div{
        flex: 1;
        width: 100%;
        height: 80px;
        line-height: 80px;
      }
      .code-input{ 
        border-bottom: 1px solid #e2e8f0;
        input{
          width: 100%;
          height: 80px;
          line-height: 80px;
          border: none;
          background: none;
          font-size: 34px;
          margin-top: -10px;
        }
      }
      .code-btn{
        text-align: center;
        color: #64748b;
      }
      .code-btn-active{
        border-radius: 40px;
        color: #fff;
        background: #3b82f6;
      }
      .code-btn-no{
        background: #e2e8f0;
        color: #fff;
        border-radius: 40px;
      }
    }
    .now-code-get{
      height: 80px;
      line-height: 80px;
      border-radius: 40px;
      color: #fff;
      background: #3b82f6;
      text-align: center;
      margin-top: 40px;
    }
  }
  
}

</style>


